import { CommodityMilestone, MilestoneStatusCode, UnitOfMeasure } from '@bechtel/types';

export interface WeldFlageConnectionProps {
  close: () => void;
  weldIds: string[];
  itrRequired: boolean;
  isUnitOfMeasureHour: boolean;
}

export interface WeldMilestoneStylingProps {
  status: MilestoneStatusCode;
  isAssigned?: boolean;
  disabled?: boolean;
  isFitupRequired?: boolean;
  isFitupMilestone?: boolean;
}

export interface WeldFlangeTab {
  label: string;
  value: WeldFlangeTabType;
}

export enum WeldFlangeTabType {
  WELDS = 'Welds',
  FLANGE_CONNECTIONS = 'Flange Connections',
}

export const FitupMilestoneMock: CommodityMilestone = {
  id: 'fitup-milestone',
  name: 'Fitup',
  hours: 0,
  blocks: [],
  attachments: [],
  weldStatuses: [],
  currentStatus: { codeI18n: MilestoneStatusCode.NOT_APPLICABLE },
};
